import React from 'react'
import styles from "./RefundPolicies.module.scss"
import { Container, Row } from 'reactstrap'
import DynamicButton from '../../../../components/common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton'
import NextIcon from "../../../../assets/icons/Admin/nextBtn.svg"

function RefundPolicies() {
    return (
        <div className={styles.mainContainer}>
            <Container fluid className={styles.orderWrapper}>
                <h5 className={styles.mainHeading}>Refund Policies and Guidelines</h5>
            </Container>
            <h5 className={styles.secHeading}>Policy Guidelines</h5>
            <div className={styles.leastHeading}>Eligibilty</div>
            <div className={styles.container}>

                <div className={styles.row}>
                    <div className={styles.div}>
                        <div className={styles.keyText}>
                            Time Frame:
                        </div>
                        <div className={styles.keyText}>
                            Condition:
                        </div>
                        <div className={styles.keyText}>
                            Exceptions:
                        </div>
                    </div>

                    <div>
                        <div className={styles.valText}>
                            Within 30 days of delivery
                        </div>
                        <div className={styles.valText}>
                            Original condition and packaging
                        </div>
                        <div className={styles.valText}>
                            Perishable goods, personalized items
                        </div>
                    </div>
                </div>


            </div>
            <h5 className={styles.secHeading}>Return and Refund Policies</h5>
            <DynamicButton theme='sky-blue'>
                <div>
                    Upload Return/Refund Policy
                    <img src={NextIcon} className={styles.img} />
                </div>
            </DynamicButton>
        </div>
    )
}

export default RefundPolicies
